import React from 'react'

const ApiIcon = () => {
  return (
    <svg
      width="68"
      height="64"
      viewBox="0 0 68 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1796 5.5433L54.2261 20.0039V48.9252L29.1796 63.3858L4.13301 48.9252V20.0039L29.1796 5.5433Z"
        fill="#018065"
      />
      <path
        d="M38.8202 0L63.8667 14.4606L63.8667 43.3819L38.8202 57.8425L13.7736 43.3819L13.7736 14.4606L38.8202 0Z"
        fill="#09AA89"
      />
      <path
        d="M28.0781 26.5156L29.8398 31.1133H26.2949L28.0781 26.5156ZM32.0957 37H36.1562L30.0332 21.9609H26.2734L20.1289 37H24.0176L25.0918 34.25H31.043L32.0957 37ZM44.3203 32.0586C47.8223 32.0586 50.1641 30.0391 50.1641 27.0098C50.1641 23.959 47.8223 21.9609 44.3203 21.9609H37.7891V37H41.8281V32.0586H44.3203ZM46.0391 27.0098C46.0391 28.1699 45.2656 28.7715 43.9766 28.7715H41.8281V25.248H43.9766C45.2656 25.248 46.0391 25.8281 46.0391 27.0098ZM52.248 37H56.2871V21.9609H52.248V37Z"
        fill="white"
      />
    </svg>
  )
}

export default ApiIcon
